module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Abby Green\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Abby Green spent her teens reading Mills & Boon romances. She then spent many years working in the Film and TV industry as an Assistant Director. One day while standing outside an actor's trailer in the rain, she thought: "), _c('I', [_vm._v("there has to be more than this. ")]), _vm._v("So she sent off a partial to Harlequin Mills & Boon. After many rewrites, they accepted her first book and an author was born. She lives in Dublin, Ireland and you can find out more here: www.abby-green.com")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5qMMlc/tc-custom/9781459212077.jpg?1706382901839",
      "alt": "This image is the cover for the book Stolen Bride, The Notorious Wolfes"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stolen Bride, The Notorious Wolfes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Sebastian Sharp. Cool. Controlled.")]), _c('br'), _c('br'), _vm._v("Ruthless in business and revered by many, Sebastian is at the top of his game professionally. Emotionally, he keeps himself alone, aloof and almost untouchable. Some say his heart is made of stone."), _c('br'), _c('br'), _vm._v("Escaping her sham of a wedding, Bollywood star Aneesa Adani takes one look at ice-cool Sebastian and is hooked! Now he's harboring this stolen bride in his penthouse, and the passionate Aneesa is the biggest risk Sebastian has ever faced. Letting her close could ignite the fire that melts even the hardest of hearts"), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0